import MyDialog from "~/mui/MyDialog";
import { checkForErrorsState } from '~/utils/utils';
import { useTrans } from '~/hooks/useTrans';
import { apiUpdateProject } from '~/providers/api';
import { IAdminProject } from '~/providers/admin-interfaces';
import { IUrlParams } from "~/interfaces";
import { myUseState } from "~/hooks/myUseState";
import { useLang } from "~/hooks/useLang";
import Wysiwyg, { contentToHTML, htmlToContent, IWysiwygContent } from "~/components/Wysiwyg";
import { MAX_INT_DESCIPTION_LEN } from "~/const";

interface IState {
	dialogLoading: boolean;
	errorMsg: string;
	wasChanged: boolean;
	desc: IWysiwygContent;
}

interface IErrors {
	desc: string;
}

interface IAdminProjectChangeInternalDescModal {
	params: IUrlParams;
	projectData: IAdminProject;
	onSave?: (project: IAdminProject) => void;
	onClose?: () => void;
	onChange?: (isChanged: boolean) => void;
}

export default function AdminProjectChangeInternalDescModal({
	params = null,
	projectData = null,
	onSave = () => {},
	onClose = () => {},
	onChange = () => {},
}: IAdminProjectChangeInternalDescModal) {
	const { trans } = useTrans();
	const { lang } = useLang();
	const { state, updateState } = myUseState<IState>({
		dialogLoading: false,
		errorMsg: "",
		wasChanged: false,
		desc: htmlToContent(projectData.internalDescription),
	});
	const { state: stateError, setState: setStateError } = myUseState<IErrors>({
		desc: "",
	});

	function getWasChangedState(newState: Partial<IState>): boolean {
		const newStateData = {
			...state,
			...newState,
		};
		const descChange = newStateData.desc && contentToHTML(newStateData.desc) !== projectData.internalDescription;

		return descChange;
	}

	function updateFormDataWithChange(stateData: Partial<IState>) {
		const wasChanged = getWasChangedState(stateData);

		updateState({
			wasChanged,
			...stateData,
		});
		onChange(wasChanged);
	}

	async function dialogOnSave() {
		const checkData: IErrors = {
			desc: state.desc?.getPlainText() || "",
		};
		const errorData = checkForErrorsState<IErrors, IErrors>(checkData, {
			desc: { check: "string-int-desc", msg: trans("createProject.error.internalDescriptionCount", { count: MAX_INT_DESCIPTION_LEN }) },
		});

		setStateError(errorData.errorsState);

		// jsou tam chyby
		if (errorData.errorsCount > 0) {
			return;
		}

		const outputData = await apiUpdateProject("admin", params.projectId, {
			internalDescription: contentToHTML(state.desc),
			userTitle: projectData.userTitle,
			userDescription: projectData.userDescription,
			internalSwitch: projectData.internalSwitch,
			userSwitch: projectData.userSwitch,
			validTill: projectData.validTill,
			lastUpdate: projectData.lastUpdate,
		}, lang);

		if (outputData.noErrors) {
			onSave(outputData.data);
		} else {
			updateState({
				dialogLoading: false,
				errorMsg: outputData.errors.join(", "),
			});
		}
	}

	return <MyDialog title={trans("adminProjectChangeInternalDescModal.title")} onClose={onClose} onSave={dialogOnSave} className="adminProjectChangeInternalDescModal" dialogLoading={state.dialogLoading} disableSave={!state.wasChanged}
		errorMsg={state.errorMsg} confirmClose={state.wasChanged} minWidth="550px">
		<Wysiwyg title={trans("adminProjectChangeInternalDescModal.internalDesc")} content={state.desc} error={stateError.desc} onChange={content => updateFormDataWithChange({ desc: content })} />
	</MyDialog>;
}
